import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import About from './components/About';
import QuoteForm from './components/QuoteForm';
import ServiceArea from './components/ServiceArea';
import Footer from './components/Footer';
import CloudBackground from './components/CloudBackground';
import { Toaster } from 'sonner';
import './App.css';
import './components/CloudBackground.css';

function App() {
  return (
    <div className="App">
      <CloudBackground />
      <Header />
      <Hero />
      <Services />
      <WhyChooseUs />
      <About />
      <QuoteForm />
      <ServiceArea />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
